module.exports = global.config = {
  host: "https://api-gateway.sampangkab.go.id/be-pkmbanyuanyar",
  //subdomain: "pkmbanyuanyar", 
};
